/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { ScrollView } from "react-native";
import { Editor } from "draft-js";

import { styles } from "UpduoLibrary";
import {
  skaleWebBackgroundGray,
  skaleWebTextBackgroundLightGray,
  upduoPrimaryBlue,
} from "config/UpduoColors";
import useSkillDescription from "./useSkillDescription";

interface SkillDescriptionProps {
  description: string;
  onEdit: (newDescription: string) => void;
  webBackground?: boolean;
  isHtml?: boolean;
  maxLength?: null | number;
  setContentLength?: (length: number) => void;
}

/**
 * Component for skill description displaying/editing
 */
export default function SkillDescription({
  description,
  onEdit,
  webBackground,
  isHtml = true,
  maxLength = null,
  setContentLength,
}: SkillDescriptionProps) {
  const { editorState, _handleChange, _handleBeforeInput, _handlePastedText } =
    useSkillDescription({
      description,
      onEdit,
      isHtml,
      maxLength,
      setContentLength,
    });

  const [editorOnFocus, setEditorOnFocus] = useState(false);

  const backgroundStyles = webBackground
    ? {
        backgroundColor: skaleWebTextBackgroundLightGray,
      }
    : {};

  return (
    <ScrollView
      style={[
        styles.descriptionInput,
        { paddingTop: isHtml ? 0 : 10, borderWidth: 1, borderStyle: "solid" },
        editorOnFocus
          ? { borderColor: upduoPrimaryBlue }
          : { borderColor: skaleWebBackgroundGray },
        backgroundStyles,
      ]}
    >
      <Editor
        editorState={editorState}
        onChange={_handleChange}
        onFocus={() => {
          setEditorOnFocus(true);
        }}
        onBlur={() => {
          setEditorOnFocus(false);
        }}
        handleBeforeInput={_handleBeforeInput}
        handlePastedText={_handlePastedText}
      />
    </ScrollView>
  );
}
